import * as signalR from "@microsoft/signalr"
import { log } from '_services'
import { dashboardActions, notesReqApprovalActions, notesPendingActionActions, pnDueActions, dcDueActions, specProgReqActions, federalReviewActions, diaryActions } from '_actions';
import { store } from '_helpers'

export const notificationService = {
    startService,
    stopService
};

var connection = undefined;
var stopped = true;

function startService() {
    var reconnectPolicy = new SapphireReconnectPolicy();

    connection = new signalR.HubConnectionBuilder()
        .withUrl(process.env.REACT_APP_API_URI + '/pteroHub', {
            accessTokenFactory: () => {
                const companyId = sessionStorage.getItem('companyId');
                if(companyId !== null && companyId !== undefined && localStorage.getItem(`pterotoken_${companyId}`) !== null)
                    {
                        return localStorage.getItem(`pterotoken_${companyId}`);
                    }
                return localStorage.getItem(`pterotoken`);
            }
        })
        .withAutomaticReconnect(reconnectPolicy)
        .configureLogging(signalR.LogLevel.Information)
        .build();

    async function start() {
        try {
            await connection.start();
            stopped = false;
            console.log("connected");
        } catch (err) {
            console.log(err);
            setTimeout(() => { if (!stopped) start() }, 5000);
        }
    };

    connection.on("ReceiveMessage", (mpno) => {
        const encodedMsg = 'NOTIFICATION: ' + mpno;
        log.info(encodedMsg);

        switch (mpno) {
            case 1: // schedule
                store.dispatch(dashboardActions.loadScheduleQuiet(store.getState().ui.dashboard.date));
                store.dispatch(dashboardActions.loadTodaysScheduleQuiet());
                store.dispatch(dashboardActions.loadOutstandingNotesQuiet());
                break;
            case 2: // notes requiring approval
                store.dispatch(notesReqApprovalActions.load());
                store.dispatch(dashboardActions.loadOutstandingNotesQuiet());
                break;
            case 3: // notes pending action
                store.dispatch(notesPendingActionActions.load());
                store.dispatch(dashboardActions.loadOutstandingNotesQuiet());
                break;
            case 4: // peer review WC
                // TODO - peer review WC notification
                break;
            case 5: // peer review Federal
                store.dispatch(federalReviewActions.load());
                break;
            case 6: // peer review specialty prog.
                store.dispatch(specProgReqActions.load());
                break;
            case 7: // PN Due
                store.dispatch(pnDueActions.load());
                break;
            case 8: // DC Due
                store.dispatch(dcDueActions.load());
                break;
            case 9: // Diary Task
                store.dispatch(diaryActions.load());
                break;
            case 10: // Release Notes
                // TODO - release notes notification
                break;
            default:
                break;
        }

    });

    // Start the connection.
    start();
}

function stopService() {
    if (connection !== undefined) {
        connection.stop();
        stopped = true;
    }
}


var SapphireReconnectPolicy = (function () {

    function SapphireReconnectPolicy() { }

    SapphireReconnectPolicy.prototype.nextRetryDelayInMilliseconds = function (retryContext) {
        return retryContext.elapsedMilliseconds < 120000 ? 5000 : 15000;
    };

    return SapphireReconnectPolicy;

}());